import * as ActionTypes from 'constants';
import { callApi } from 'api';

export const beginInitRoles = () => ({
	type : ActionTypes.BEGIN_INIT_ROLES
})

export const beginAddRoles = (role) => ({
	type : ActionTypes.BEGIN_ADD_ROLE,
	payload : role
})

export const beginEnableFeatures = (features) => ({
	type : ActionTypes.BEGIN_ENABLE_FEATURES,
	payload : features
})

export const beginDisableFeatures = (features) => ({
	type : ActionTypes.BEGIN_DISABLE_FEATURES,
	payload : features
})

export const initializeRoles = (roles) => {
	return {
		type : ActionTypes.INITIALIZE_ROLES,
		payload : {roles}
	}
}

export const handleClickRole = (role_id) => ({
	type : ActionTypes.HANDLE_CLICK_ROLE,
	payload : role_id
})

export const changeSelectedRole = (selectedRole) => {
	return {
		type : ActionTypes.CHANGE_SELECTED_ROLE,
		payload : {selectedRole}
	}
}

export const updateRole = (role) => ({
	type : ActionTypes.UPDATE_ROLE,
	payload : role
})

export const toggleShowFeatures = (showFeatures) => {
	return {
		type : ActionTypes.SHOW_FEATURES,
		payload : {showFeatures}
	}
}

export const addFeatureToRole = (role_id, features) => {
	return {
		type : ActionTypes.ADD_FEATURE_TO_STATE,
		payload : {role_id, features}
	}
}

export const removeFeatureFromRole = (role_id, features_list) => {
	return {
		type : ActionTypes.REMOVE_FEATURE_FROM_STATE,
		payload : {role_id, features_list}
	}
}

export const addRoleToState = (role) => {
	return {
		type : ActionTypes.ADD_ROLE_TO_STATE,
		payload : {role}
	}
}

export const beginDeleteRole = (role) => ({
	type : ActionTypes.BEGIN_DELETE_ROLE,
	payload : role
})

export const deleteRoleFromState = (role_id) => {
	return {
		type : ActionTypes.DELETE_ROLE_FROM_STATE,
		payload : {role_id}
	}
}

export const showDeleteRoleModal = () => ({
	type : ActionTypes.SHOW_DELETE_ROLE_MODAL
})

export const hideDeleteRoleModal = () => ({
	type : ActionTypes.HIDE_DELETE_ROLE_MODAL
})

export const getRoles = (callback) => {
	return (dispatch, getState) => {
		callApi('GET', '/roles')
			.then(confirmation => {
				if (callback)
					callback(null, confirmation);
			})
			.catch(error => {
				if(callback)
					callback(error, null);
			});
	}
}

export const addFeatureToDB = (role_id, features, callback) => {
	return (dispatch, getState) => {
		callApi('PUT', '/roles/enable-feature', { role_id, features: JSON.stringify(features) }, 'application/json')
			.then(confirmation => callback? callback(null, confirmation) : null)
			.catch(callback? callback : (() => {}));
	}
}

export const removeFeatureFromDB = (role_id, features, callback) => {
	return (dispatch, getState) => {
		callApi('PUT', '/roles/disable-feature', { role_id, features }, 'application/json')
			.then(confirmation => {
				if (callback)
					callback(null, confirmation)
			})
			.catch(error => {
				if(callback)
					callback(error,null);
			});
	}
}

export const addRoleToDB = (name, group, callback) => {
	return (dispatch, getState) => {
		callApi('POST', '/roles/add-role', { name, group }, 'application/json')
			.then(confirmation => {
				if (callback)
					callback(null, confirmation);
			})
			.catch(error => {
				if (callback)
					callback(error, null);
			});
	}
}

export const deleteRoleFromDB = (id, callback) => {
	return (dispatch, getState) => {
		callApi('DELETE', '/roles/delete-role', { id }, 'application/json')
			.then(confirmation => {
				if(callback)
					callback(null, confirmation);
			})
			.catch(error => {
				if(callback)
					callback(error, null);
			});
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/roleManagement.js